<template>
    <cmpTableWithMenu v-bind:name="name"
                      v-bind:pkColumn="pkColumn"
                      v-bind:fields="fields"
                      v-bind:qryFields="qryFields"
                      v-bind:children="children"
                      v-bind:parent="parent"
                      v-bind:header="header"
                      v-bind:tableFuncs="tableFuncs"
                      v-bind:moreTableFuncs="moreTableFuncs"></cmpTableWithMenu>
</template>

<script>
    import i18n from '@/i18n'
    import cmpTableWithMenu from "@/components/common/cmpTableWithMenu"
    export default {
        components: {
            cmpTableWithMenu
        },
        computed: {
            fields() {
                return [
                    { "key": "Operation", "label": i18n.t('component.operation'), tdClass: 'text-center', thClass: 'text-center' },
                    { "key": "No", "label": "No." },
                    { "key": "ParametervarSect", "label": i18n.t('component.SysParameter.ParametervarSect.label'), sortable: true },
                    { "key": "ParametervarName", "label": i18n.t('component.SysParameter.ParametervarName.label'), sortable: true },
                    { "key": "ParametervarValue", "label": i18n.t('component.SysParameter.ParametervarValue.label'), sortable: true },
                ]
            },
            qryFields() {
                return [
                    { "key": "ParametervarSect", "label": i18n.t('component.SysParameter.ParametervarSect.label'), input: { type: "text" } },
                    { "key": "ParametervarName", "label": i18n.t('component.SysParameter.ParametervarName.label'), input: { type: "text" } },
                    { "key": "ParametervarValue", "label": i18n.t('component.SysParameter.ParametervarValue.label'), input: { type: "text" } },
                ]
            }
            ,
            header() {
                return i18n.t('component.SysParameter.lstHeader')
            }
        },
        data() {

            return {
                name: "SysParameter",
                pkColumn: "SysParameterId",
                children: {},
                parent: {},
                tableFuncs: ['rec', 'copyNew', 'edit', 'delete'],
                moreTableFuncs: []
            };
        }
    }
</script>